<template>
  <div class="change-state-form bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
    <div class="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
      <div class="ml-4 mt-4">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          Change the Status
        </h3>
        <p class="mt-1 text-sm leading-5 text-gray-500">
          All of the {{ modelPrettified }} that have been selected will be altered to have the status of your choice.
        </p>
      </div>
    </div>
    <div class="modal-body">
      <multiselect
        v-model="selectedState"
        :options="states"
        placeholder="Select status"
        :show-labels="false"
        :multiple="false"
      />
      <div v-show="showReasonForm" class="p-6 standard-form">
        <div class="pb-4 text-xl">{{stateNamePrettified}} details for {{ modelPrettified }}</div>

        <div class="standard-field-wrapper">
          <label for="action_date">{{stateNamePrettified}} Date</label>
          <div class="standard-input-wrapper">
            <div class="standard-input-container w-32">
              <input type="text" name="action_date" ref="datepicker" v-model="action_date" class="datepicker">
            </div>
          </div>
        </div>
        <div class="standard-field-wrapper" v-if="selectedState=='dropped' && this.model!='Church'">
          <label for="action_reason_code">{{stateNamePrettified}} Reason</label>
          <multiselect class="multiselector"
            v-model="selectedReason"
            :options="options.droppedReasons"
            label="name"
            track-by="value"
            placeholder="Select dropped reason"
            :show-labels="false"
            :multiple="false"
          />
        </div>
        <div class="standard-field-wrapper" v-if="selectedState != 'graduated'">
          <label for="action_reason_text">Reason Notes</label>
          <div class="standard-input-wrapper">
            <div class="standard-input-container">
              <textarea rows="6" name="action_reason_text" v-model="action_reason_text"></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="action-buttons">
        <button type="button" class="btn btn-danger" @click="close()">Cancel</button>
        <button type="button" class="btn btn-primary" @click="submit" :disabled="!selectedState">Submit</button>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { startCase } from 'lodash-es'
  import Multiselect from 'vue-multiselect'
  import BulkActionService from '@services/BulkActionService'
  import FlashMessages from '@services/FlashMessages'
  import flatpickr from 'flatpickr'

  export default {
    name: 'assign-reporting-entities-form',
    components: {
      Multiselect,
    },
    data () {
      const states = ['active', 'dropped', 'graduated', 'under_review', 'suspended'];
      return {
        states,
        selectedState: null,
        selectedReason: null,
        action_date: null,
        action_reason_text: null,
        processing: false,
      }
    },
    computed: {
      modelPrettified () {
        const pluralSuffix = this.model.endsWith('ch') ? 'es' : 's'
        return startCase(this.model) + pluralSuffix
      },
      stateNamePrettified () {
        return this.selectedState ? startCase(this.selectedState.replace('_',' ')) : ''
      },
      showReasonForm () {
        if (this.model == 'Church'){
          return 'dropped,under_review,suspended'.includes(this.selectedState)
        } else {
          return 'dropped,under_review,graduated,suspended'.includes(this.selectedState)
        }
      },
      action_reason_code () {
        return this.selectedReason ? this.selectedReason.value : ''
      },
      validationErrors () {
        var errorText = ''
        switch(this.selectedState){
          case 'dropped':
            errorText = !this.action_date || (!this.action_reason_code && this.model !== 'Church') || !this.action_reason_code ? 'Dropped date, reason, and reason notes are required' : ''
            break;
          case 'under_review':
            errorText = !this.action_date || !this.action_reason_text ? 'Under Review date and reason notes are required' : ''
            break;
          case 'graduated':
            errorText = !this.action_date && this.model !== 'Church' ? 'Graduation Date is Required' : ''
            break;
        }
        return errorText
      }
    },
    methods: {
      cancel () {
        this.$emit('cancel')
      },
      close () {
        this.$emit('close')
      },
      submit () {
        if (!this.processing) {
          this.processing = true
          if (this.validationErrors == '') {
            BulkActionService.changeState(this.ids, this.model, this.selectedState, this.action_date, this.action_reason_code, this.action_reason_text)
              .then(resp => {
                FlashMessages.success(`Status changed to \"${this.selectedState}\" on ${resp.data.result} record(s).`, 'Success')
                this.close()
              })
              .catch(resp => {
                FlashMessages.error(`Failed to change status. Please try again later.`, 'Error')
                this.close()
              })
          } else {
            FlashMessages.error(this.validationErrors)
          }
        }
      },
    },
    created () {
      let itvl = setInterval(() => {
        if (this.$refs.datepicker) {
          flatpickr(this.$refs.datepicker)
          clearInterval(itvl)
        }
      }, 50)
    },
    props: {
      ids: {
        type: Array,
        required: true,
      },
      model: {
        type: String,
        required: true,
      },
      options: {
        type: Object,
        required: false,
      },
    },
  }
</script>

<style lang="scss">
  .change-state-form {
    .modal-body {
      margin-top: 15px;

      .action-buttons {
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
      }
      .multiselector {
        margin-top: 5px;
        min-width: 20rem;
        max-width: 20rem;
      }
    }
  }
</style>
